import {
	TERMS_OF_SERVICE_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[TERMS_OF_SERVICE_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'termsOfService',
	},
}
